
function change(element) {
  element.forEach((el) => {
    if (el.classList.contains('shown-text')) {
      el.classList.remove('shown-text');
      el.classList.add('hidden-text');
    } else {
      el.classList.remove('hidden-text');
      el.classList.add('shown-text');
    }
  });
}

let textBlock = document.querySelector('.animate-text');
let pargraph = textBlock.querySelectorAll('P');

let count = 1000;
let ms = 5000;
let i = 0;

function getText() {
  change(pargraph);
  i += 1;
  setTimeout(function () {
    if (i < count) {
      getText();
    }
  }, ms);
}

export {getText};
